import React, { useEffect, useState } from "react";
import { deepCopy } from "../../Shared/Utility/DeepCopy";
import { Note } from "../../Shared/Models/Note";
import { getDateWithOffset } from "../../Shared/Utility/GetDateWithOffset";
import { Button } from "react-bootstrap";
import { ValidatorHelper } from "../../Shared/Utility/ValidatorHelper";
import AbpnSpinner from "../../Shared/Components/AbpnSpinner";

interface IProps {
    notes: Array<Note>;
    formId: string;
    isReadOnly: boolean;
    onSaving: (note: Note) => void;
}

export function NotesGrid(props: IProps) {
    const [notes, setNotes] = useState<Array<Note>>(props.notes);
    const [newNote, setNewNote] = useState<Note>(new Note());
    const [isAddingNote, setIsAddingNote] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    useEffect(() => {
        if(props.notes.length > notes.length){
            setNewNote(new Note())
            document.getElementById(props.formId).classList.remove('was-validated');
        }
        setNotes(props.notes);
        setIsLoading(false)
    }, [props.notes]);

    const updateNewNote = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        let noteContentInput = document.getElementById(`${props.formId}TextArea`) as HTMLInputElement;
        let updatedNote = deepCopy(newNote);

        updatedNote.content = event.target.value;
        ValidatorHelper.clearCustomValidation(noteContentInput);
        setNewNote(updatedNote);
    }

    const saveNote = () => {
        let notesForm = document.getElementById(props.formId);
        let noteContentInput = document.getElementById(`${props.formId}TextArea`) as HTMLInputElement;

        if (!newNote.content || !newNote.content.trim().length) {
          noteContentInput.setCustomValidity("Please enter a note");
          ValidatorHelper.setCustomValidationWithFeedback(noteContentInput, "Please enter a note.")
        }
        else {
          setIsLoading(true);
          props.onSaving(newNote);
          setIsAddingNote(false)
        }

        notesForm.classList.add('was-validated');
    }

    const cancelNote = () => {
        let noteContentInput = document.getElementById(`${props.formId}TextArea`) as HTMLInputElement;
        ValidatorHelper.clearCustomValidation(noteContentInput);
        setIsAddingNote(false)
        setNewNote(new Note())
    }

    if (!props.formId) return null;
    return (
        <div>
            <p hidden={notes.length > 0 || isAddingNote || isLoading} className="mb-0">No Notes</p>
            <div hidden={notes.length === 0} className="small" style={{ maxHeight: '500px', overflow: 'auto' }}>
                <div>
                    {notes.map((value, index) => {
                        return (
                            <div key={index} className="flex-row justify-content-start mb-3">
                                <div className={`p-2 ms-0 ${value.createdBy === "ABPN Credentials" ? 'nonPreCertNote' : 'preCertNote'}`}>
                                        <div>
                                            <span className="fw-bold p-1">
                                                {value.createdBy}
                                            </span>
                                            <span className="p-1" hidden={value.createdDate === null}>
                                                {getDateWithOffset(value.createdDate?.toString())?.toLocaleDateString()}
                                            </span>
                                        </div>
                                        <p className="mb-0 p-1">{value.content}</p>
                                </div>
                            </div>
                        )
                    })}
            </div>
            </div>
            {isLoading ? <AbpnSpinner /> :
                <>
                    <div hidden={!isAddingNote || props.isReadOnly} className="form-outline mb-3" id={props.formId}>
                        <textarea className="form-control" id={`${props.formId}TextArea`} rows={2} value={newNote?.content ?? ''} onChange={e => updateNewNote(e)}></textarea>
                        <span className="invalid-feedback"></span>
                        <div className="float-end">
                            <Button type="button" onClick={() => saveNote()} variant="primary" className="font-sm mx-2 mt-2 btn-sm pc-button">Save Note</Button>
                            <Button type="button" onClick={() => cancelNote()} variant="outline-secondary" className="font-sm mt-2 btn-sm pc-button">Cancel</Button>
                        </div>
                    </div>
                    <Button hidden={isAddingNote || props.isReadOnly} type="button" onClick={() => setIsAddingNote(true)} variant="primary" className="font-sm float-end mt-2 btn-sm pc-button">Add Note</Button>
                </>
            }
        </div>
    );
}
